import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = ProjectVenue[];

export const getProjectsVenue = createAppAsyncThunk(
  'projectVenue/getProjectsVenue',
  async (
    _,
    { extra: { projectVenueGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const projects = await projectVenueGateway.getAll();
      return projects;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetProjects.Message.error'));
}
